import * as React from "react";
import * as moment from "moment";
import { Base } from "ui/Scripts/source/framework/base";
import { LocalizationProvider, TimePicker as MuiTimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export interface ITimePickerProp {
    autoFocus?: boolean;
    disabled?: boolean;
    required?: boolean;
    value: string;
    minTime?: string;
    onChange(value: string);
}

export const TimePicker = ({ value, disabled, required, autoFocus, minTime, onChange }: ITimePickerProp) => {
    const handleChange = (value: moment.Moment | string) => {
        const isString = Base.isString(value);
        onChange(isString
            ? (value ?? "")
            : Base.timeToTimeStr(value));
    };

    const getLanguageLocale = (culture: string) => {
        switch (culture) {
        case "fi":
            return "fi";
        case "en":
        case "en-US":
            return "en";
        case "sv":
            return "se";
        }
    };

    const getLocaleTime = (stringTime: string) => {
        if (!stringTime) return null;
        return moment.utc(stringTime.toUtcTime());
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={getLanguageLocale(appConfig.culture)}>
            <MuiTimePicker
                value={getLocaleTime(value)}
                disabled={disabled}
                autoFocus={autoFocus}
                onChange={handleChange}
                minTime={minTime ? getLocaleTime(minTime) : undefined}
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                sx={{ width: "100% " }}
            />
        </LocalizationProvider>
    );
};
